<section class="tickets-toolbar">
  <div class="tickets-filter">
    <label [for]="prefijo + '-anio'">Año</label>
    <div class="tickets-select">
      <mat-icon aria-hidden="true">event</mat-icon>
      <select [id]="prefijo + '-anio'" [(ngModel)]="anio" (ngModelChange)="onAnio()" [disabled]="cargando || deshabilitado">
        <option *ngFor="let opcion of anios" [ngValue]="opcion.anio">{{ opcion.texto }}</option>
      </select>
    </div>
  </div>

  <div class="tickets-filter" *ngIf="mostrarCorte">
    <label [for]="prefijo + '-corte'">Corte</label>
    <div class="tickets-select">
      <mat-icon aria-hidden="true">date_range</mat-icon>
      <select [id]="prefijo + '-corte'" [(ngModel)]="corte" (ngModelChange)="onCorte()" [disabled]="cargando || deshabilitado">
        <option *ngFor="let c of cortes" [ngValue]="c.valor">{{ c.texto }}</option>
      </select>
    </div>
  </div>

  <p class="tickets-toolbar__note selector-corte-bsc__error" *ngIf="error" role="alert">{{ error }}</p>

  <ng-content select="[meta]"></ng-content>
</section>
